/**
 * @generated SignedSource<<78beaa8dbe92dac89e2fba1c43fb90c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type organizationpermission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
export type ResourceGroupLinkInput = {
  resourceGroupNodeId: string;
  resourceGroupPermission: organizationpermission;
};
export type inviteUsersMutation$variables = {
  emails: ReadonlyArray<string>;
  expiry?: string | null;
  orgId: string;
  orgPermission?: organizationpermission | null;
  resourceGroupLinks?: ReadonlyArray<ResourceGroupLinkInput | null> | null;
};
export type inviteUsersMutation$data = {
  readonly inviteUsers: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly invitedUsers: ReadonlyArray<string | null> | null;
  } | null;
};
export type inviteUsersMutation = {
  response: inviteUsersMutation$data;
  variables: inviteUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emails"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expiry"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgPermission"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceGroupLinks"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
      },
      {
        "kind": "Variable",
        "name": "expiry",
        "variableName": "expiry"
      },
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "orgPermission",
        "variableName": "orgPermission"
      },
      {
        "kind": "Variable",
        "name": "resourceGroupLinks",
        "variableName": "resourceGroupLinks"
      }
    ],
    "concreteType": "InviteUsers",
    "kind": "LinkedField",
    "name": "inviteUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invitedUsers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "inviteUsersMutation",
    "selections": (v5/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "inviteUsersMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "1d8d4b8299232b5b3902a1838ef70a19",
    "id": null,
    "metadata": {},
    "name": "inviteUsersMutation",
    "operationKind": "mutation",
    "text": "mutation inviteUsersMutation(\n  $orgId: ID!\n  $emails: [String!]!\n  $orgPermission: organizationpermission\n  $resourceGroupLinks: [ResourceGroupLinkInput]\n  $expiry: DateTime\n) {\n  inviteUsers(orgId: $orgId, emails: $emails, orgPermission: $orgPermission, resourceGroupLinks: $resourceGroupLinks, expiry: $expiry) {\n    invitedUsers\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "55918588f0074a8812d57bc8e44a650a";

export default node;
